const $4ca38318c11c7fd1$export$8e361a1ffbebf172 = {
    score: 0,
    wpm: 0,
    health: 100,
    currentWord: '',
    gameActive: true,
    difficulty: 'medium',
    mode: 'essay'
};
const $4ca38318c11c7fd1$export$874fd8712028ad21 = {
    startTime: null,
    currentEssay: '',
    essayProgress: 0,
    currentWordIndex: 0,
    wordsTyped: 0,
    wordsCount: 30,
    currentWordList: [],
    survivalDecayInterval: null,
    survivalLastTypedTime: null,
    survivalModeActive: false,
    survivalBaseDecay: 2,
    survivalCombo: 0,
    survivalComboTimer: null
};
function $4ca38318c11c7fd1$export$ee55a0351e6e0fac() {
    $4ca38318c11c7fd1$export$8e361a1ffbebf172.score = 0;
    $4ca38318c11c7fd1$export$8e361a1ffbebf172.wpm = 0;
    $4ca38318c11c7fd1$export$8e361a1ffbebf172.health = 100;
    $4ca38318c11c7fd1$export$8e361a1ffbebf172.currentWord = '';
    $4ca38318c11c7fd1$export$8e361a1ffbebf172.gameActive = true;
}
function $4ca38318c11c7fd1$export$21c3eb13a2a2693a() {
    $4ca38318c11c7fd1$export$874fd8712028ad21.startTime = null;
    $4ca38318c11c7fd1$export$874fd8712028ad21.wordsTyped = 0;
    $4ca38318c11c7fd1$export$874fd8712028ad21.currentWordIndex = 0;
    $4ca38318c11c7fd1$export$874fd8712028ad21.currentEssay = '';
    $4ca38318c11c7fd1$export$874fd8712028ad21.essayProgress = 0;
    $4ca38318c11c7fd1$export$874fd8712028ad21.survivalCombo = 0;
    $4ca38318c11c7fd1$export$874fd8712028ad21.survivalModeActive = false;
    $4ca38318c11c7fd1$export$874fd8712028ad21.survivalLastTypedTime = null;
}
function $4ca38318c11c7fd1$export$4017b8a7e96349d1() {
    if ($4ca38318c11c7fd1$export$874fd8712028ad21.survivalDecayInterval) {
        clearInterval($4ca38318c11c7fd1$export$874fd8712028ad21.survivalDecayInterval);
        $4ca38318c11c7fd1$export$874fd8712028ad21.survivalDecayInterval = null;
    }
    if ($4ca38318c11c7fd1$export$874fd8712028ad21.survivalComboTimer) {
        clearTimeout($4ca38318c11c7fd1$export$874fd8712028ad21.survivalComboTimer);
        $4ca38318c11c7fd1$export$874fd8712028ad21.survivalComboTimer = null;
    }
    $4ca38318c11c7fd1$export$874fd8712028ad21.survivalModeActive = false;
    $4ca38318c11c7fd1$export$874fd8712028ad21.survivalCombo = 0;
}


const $79d266cbe2073e61$export$7a5d735b2ab6389d = {
    appContainer: document.getElementById("appContainer"),
    themeToggle: document.getElementById("themeToggle"),
    navToggle: document.getElementById("navToggle"),
    nav: document.getElementById("nav"),
    themeContext: document.getElementById("themeContext"),
    currentWordDisplay: document.getElementById("currentWord"),
    userInput: document.getElementById("userInput"),
    essayDisplay: document.getElementById("essayDisplay"),
    wordPool: document.getElementById("wordPool"),
    scoreEl: document.getElementById("scoreValue"),
    healthEl: document.getElementById("healthValue"),
    wpmEl: document.getElementById("wpmValue"),
    progressBarContainer: document.getElementById("progress"),
    progressBar: document.getElementById("progressBar"),
    modal: document.getElementById("gameOverModal"),
    title: document.getElementById("gameOverTitle"),
    finalScoreEl: document.getElementById("finalScore"),
    finalWPMEl: document.getElementById("finalWPM"),
    playerNameInput: document.getElementById("playerName"),
    saveScore: document.getElementById("saveScore"),
    playAgain: document.getElementById("playAgain"),
    leaderboardList: document.getElementById("leaderboardList"),
    leaderboardFilter: document.querySelectorAll(".lb-filter"),
    modalCloseBtns: document.querySelectorAll(".modal-close"),
    difficultyBtns: document.querySelectorAll(".difficulty-btn"),
    modeBtns: document.querySelectorAll(".mode-btn"),
    modeHint: document.getElementById("modeHint"),
    inputHint: document.getElementById("inputHint"),
    resetBtn: document.getElementById("resetGame"),
    skipBtn: document.getElementById("skipWord"),
    commandTrigger: document.querySelector(".command-trigger")
};




function $14014bd8d985f76e$export$4cf11838cdc2a8a8(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
}
function $14014bd8d985f76e$export$483f8f5e36a4d64f(startTime, wordsTyped) {
    if (!startTime || wordsTyped === 0) return 0;
    const elapsedMs = Date.now() - startTime;
    if (elapsedMs < 3000) return 0;
    const minutes = elapsedMs / 60000;
    return Math.round(wordsTyped / minutes / 5);
}


const $45af14c00f07ca1e$export$daa7e859aba5ce88 = "type-ebx-theme";
const $45af14c00f07ca1e$export$e6ea90c0ef135c03 = 'https://random-words-api.kushcreates.com/api?language=en';
const $45af14c00f07ca1e$export$88f6f8ff4bba2e2f = 'https://baconipsum.com/api/?type=meat-and-filler&paras=1&format=text';
const $45af14c00f07ca1e$export$5aae9b6b3e0e7094 = {
    LEADERBOARD_EASY: 'ebxtype_leaderboard_easy',
    LEADERBOARD_MEDIUM: 'ebxtype_leaderboard_medium',
    LEADERBOARD_HARD: 'ebxtype_leaderboard_hard',
    STATS: 'ebxtype_stats'
};


function $b1e98e38dc5653da$export$ab10ae45fda35d88(playerName, score, difficulty) {
    const key = $b1e98e38dc5653da$var$getLeaderboardKey(difficulty);
    const leaderboard = $b1e98e38dc5653da$export$a432f328c781673f(difficulty);
    leaderboard.push({
        name: playerName.slice(0, 20),
        score: score,
        date: new Date().toISOString()
    });
    leaderboard.sort((a, b)=>b.score - a.score);
    const topScores = leaderboard.slice(0, 10);
    localStorage.setItem(key, JSON.stringify(topScores));
    $b1e98e38dc5653da$var$saveGameStats(score, difficulty);
}
function $b1e98e38dc5653da$export$a432f328c781673f(difficulty) {
    const key = $b1e98e38dc5653da$var$getLeaderboardKey(difficulty);
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
}
function $b1e98e38dc5653da$var$getLeaderboardKey(difficulty) {
    switch(difficulty){
        case 'easy':
            return (0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).LEADERBOARD_EASY;
        case 'hard':
            return (0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).LEADERBOARD_HARD;
        default:
            return (0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).LEADERBOARD_MEDIUM;
    }
}
function $b1e98e38dc5653da$export$4b80e08960f15b4f(settings) {
    localStorage.setItem((0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).SETTINGS, JSON.stringify(settings));
}
function $b1e98e38dc5653da$export$4a647155031ece() {
    const data = localStorage.getItem((0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).SETTINGS);
    return data ? JSON.parse(data) : {
        soundEnabled: true,
        theme: 'dark'
    };
}
function $b1e98e38dc5653da$var$saveGameStats(score, difficulty) {
    const stats = $b1e98e38dc5653da$export$1879224ff4747253();
    stats.totalGames = (stats.totalGames || 0) + 1;
    stats.highestScore = Math.max(stats.highestScore || 0, score);
    stats.totalScore = (stats.totalScore || 0) + score;
    stats.averageScore = Math.round(stats.totalScore / stats.totalGames);
    if (!stats[difficulty]) stats[difficulty] = {
        games: 0,
        bestScore: 0
    };
    stats[difficulty].games++;
    stats[difficulty].bestScore = Math.max(stats[difficulty].bestScore, score);
    localStorage.setItem((0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).STATS, JSON.stringify(stats));
}
function $b1e98e38dc5653da$export$1879224ff4747253() {
    const data = localStorage.getItem((0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094).STATS);
    return data ? JSON.parse(data) : {
        totalGames: 0,
        highestScore: 0,
        totalScore: 0,
        averageScore: 0
    };
}
function $b1e98e38dc5653da$export$cff6c20e7f684a69() {
    Object.values((0, $45af14c00f07ca1e$export$5aae9b6b3e0e7094)).forEach((key)=>{
        localStorage.removeItem(key);
    });
}


function $8819aed3de4d5aa9$export$5b188b9c6119dc76(score, health, wpm) {
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).scoreEl) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).scoreEl.textContent = Math.floor(score);
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl) {
        const roundedHealth = Math.min(100, Math.max(0, Math.round(health)));
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl.textContent = roundedHealth;
        if (roundedHealth < 30) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl.classList.add("low-health");
        else (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl.classList.remove("low-health");
    }
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wpmEl) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wpmEl.textContent = Math.round(wpm);
}
function $8819aed3de4d5aa9$export$a26debe12f9d939f(difficulty = "medium") {
    const leaderboardList = document.getElementById("leaderboardList");
    if (!leaderboardList) return;
    const scores = (0, $b1e98e38dc5653da$export$a432f328c781673f)(difficulty);
    if (scores.length === 0) {
        leaderboardList.innerHTML = '<div class="leaderboard-item">No scores yet. Play a game!</div>';
        return;
    }
    leaderboardList.innerHTML = scores.map((entry, index)=>`
        <div class="leaderboard-item">
            <span class="leaderboard-rank">#${index + 1}</span>
            <span class="leaderboard-name">${(0, $14014bd8d985f76e$export$4cf11838cdc2a8a8)(entry.name)}</span>
            <span class="leaderboard-score">${entry.score} pts</span>
        </div>
    `).join("");
}
function $8819aed3de4d5aa9$export$85aadf8ace5d5dad() {
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.disabled = true;
}
function $8819aed3de4d5aa9$export$841ecefba1e9cb2e() {
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.disabled = false;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.focus();
}
function $8819aed3de4d5aa9$export$35f7926bd3d84ff1() {
    const text = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay || "";
    const typed = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value;
    const compareLength = Math.max(text.length, typed.length);
    let html = "";
    for(let i = 0; i < compareLength; i++){
        const targetChar = text[i] ?? "";
        const typedChar = typed[i] ?? "";
        if (i < typed.length) {
            if (typedChar === targetChar) html += `<span class="essay-char correct">${(0, $14014bd8d985f76e$export$4cf11838cdc2a8a8)(targetChar || typedChar)}</span>`;
            else if (typedChar) html += `<span class="essay-char wrong">${(0, $14014bd8d985f76e$export$4cf11838cdc2a8a8)(targetChar || typedChar)}</span>`;
        } else if (targetChar) html += `<span class="essay-char pending">${(0, $14014bd8d985f76e$export$4cf11838cdc2a8a8)(targetChar)}</span>`;
    }
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay.innerHTML = html || '<span class="essay-char pending">Loading essay...</span>';
}
function $8819aed3de4d5aa9$export$55220155eeb8e52c() {
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        const ratio = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay.length ? (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value.length / (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay.length : 0;
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar.style.width = Math.min(ratio * 100, 100) + "%";
        return;
    }
    if (!(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex]) return;
    const word = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex];
    const percentage = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value.length / word.length * 100;
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar.style.width = Math.min(percentage, 100) + "%";
}
function $8819aed3de4d5aa9$export$42f3f63a098c5667() {
    if (!(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex]) return false;
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay.textContent = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex].toLowerCase();
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value = "";
    $8819aed3de4d5aa9$export$55220155eeb8e52c();
    return true;
}
function $8819aed3de4d5aa9$export$9d95f35147c2490c() {
    if (!(0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool) return;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.innerHTML = '<div class="pool-word essay-tag">essay mode</div><div class="pool-word next">paragraph</div>';
        return;
    }
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.innerHTML = "";
    const displayCount = (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" ? 8 : 5;
    for(let i = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex; i < Math.min((0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex + displayCount, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.length); i++){
        const el = document.createElement("div");
        el.className = "pool-word" + (i === (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex ? " next" : "");
        el.textContent = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[i];
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.appendChild(el);
    }
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" && (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.length - (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex < 10) {
        const remainingEl = document.createElement("div");
        remainingEl.className = "pool-word warning";
        remainingEl.textContent = `${(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.length - (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex} left - loading more...`;
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.appendChild(remainingEl);
    }
}
function $8819aed3de4d5aa9$export$d9daadad6102d0bd() {
    let comboElement = document.getElementById("comboDisplay");
    if (!comboElement && (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive) {
        const statsPanel = document.querySelector(".stats-panel");
        if (statsPanel && !document.getElementById("comboDisplay")) {
            const comboCard = document.createElement("div");
            comboCard.className = "stat-card";
            comboCard.innerHTML = `
        <div class="stat-label">COMBO</div>
        <div class="stat-value" id="comboDisplay">0</div>
      `;
            statsPanel.appendChild(comboCard);
        }
        comboElement = document.getElementById("comboDisplay");
    }
    if (comboElement) {
        comboElement.textContent = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo;
        if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo > 5) comboElement.style.color = "var(--accent-warning)";
        else if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo > 10) comboElement.style.color = "var(--accent-success)";
        else comboElement.style.color = "";
    }
}
function $8819aed3de4d5aa9$export$36595ab25e995ab3() {
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.remove("wrong", "correct");
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.classList.remove("show");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBarContainer.classList.add("essay");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay.classList.add("show");
        if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay.innerHTML = '<span class="essay-char pending">Loading essay...</span>';
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).essayProgress = 0;
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay.textContent = "essay task";
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.remove("word-mode");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.add("essay-mode");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.setAttribute("rows", 7);
    } else {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).wordPool.classList.add("show");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay.classList.remove("show");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBarContainer.classList.remove("essay");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.remove("essay-mode");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.setAttribute("rows", 1);
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay.textContent = "loading...";
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay.classList.add("survival-mode");
        else (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay.classList.remove("survival-mode");
    }
}




function $c7e6200d021cfc4e$export$b11a7e24e0f6e0cc() {
    document.querySelectorAll(".modal").forEach((m)=>m.classList.remove("active"));
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).appContainer.classList.remove("no-scroll");
}
function $c7e6200d021cfc4e$export$3acec85c603510fd() {
    (0, $8819aed3de4d5aa9$export$a26debe12f9d939f)("medium");
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).leaderboardFilter.forEach((f)=>f.classList.remove("active"));
    const med = document.querySelector('[data-lb="medium"]');
    if (med) med.classList.add("active");
    const modal = document.getElementById("leaderboardModal");
    if (modal) modal.classList.add("active");
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).appContainer.classList.add("no-scroll");
}
function $c7e6200d021cfc4e$export$bb9d9652d2452909() {
    const modal = document.getElementById("aboutModal");
    if (modal) modal.classList.add("active");
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).appContainer.classList.add("no-scroll");
}
function $c7e6200d021cfc4e$export$bcb53ae2a77812e7(title, score, wpm) {
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).title) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).title.textContent = title;
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).finalScoreEl) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).finalScoreEl.textContent = score;
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).finalWPMEl) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).finalWPMEl.textContent = wpm;
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).playerNameInput) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).playerNameInput.value = "";
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modal) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modal.classList.add("active");
}



function $ace5d9ab79ecc0da$export$a1d87755f3c9500d() {
    return localStorage.getItem((0, $45af14c00f07ca1e$export$daa7e859aba5ce88)) || $ace5d9ab79ecc0da$export$fe979c3403443f94();
}
function $ace5d9ab79ecc0da$export$fe979c3403443f94() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function $ace5d9ab79ecc0da$export$49e16ec648d05eb2(theme, themeToggle, themeContext) {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem((0, $45af14c00f07ca1e$export$daa7e859aba5ce88), theme);
    if (themeToggle) {
        themeToggle.setAttribute("aria-label", `Activate ${theme === "dark" ? "light" : "dark"} mode`);
        themeContext.textContent = theme === 'dark' ? 'Light mode' : 'Dark mode';
    }
}
function $ace5d9ab79ecc0da$export$55990aefc4a243a0() {
    const currentTheme = $ace5d9ab79ecc0da$export$a1d87755f3c9500d();
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    $ace5d9ab79ecc0da$export$49e16ec648d05eb2(newTheme, document.getElementById("themeToggle"), document.getElementById("themeContext"));
}



// English 1K common words list
const $9012767c86612ea9$export$493d50d03d937fb6 = [
    'the',
    'be',
    'to',
    'of',
    'and',
    'a',
    'in',
    'that',
    'have',
    'i',
    'it',
    'for',
    'not',
    'on',
    'with',
    'he',
    'as',
    'you',
    'do',
    'at',
    'this',
    'but',
    'his',
    'by',
    'from',
    'they',
    'we',
    'say',
    'her',
    'she',
    'or',
    'an',
    'will',
    'my',
    'one',
    'all',
    'would',
    'there',
    'their',
    'what',
    'so',
    'up',
    'out',
    'if',
    'about',
    'who',
    'get',
    'which',
    'go',
    'me',
    'when',
    'make',
    'can',
    'like',
    'time',
    'no',
    'just',
    'him',
    'know',
    'take',
    'people',
    'into',
    'year',
    'your',
    'good',
    'some',
    'could',
    'them',
    'see',
    'other',
    'than',
    'then',
    'now',
    'look',
    'only',
    'come',
    'its',
    'over',
    'think',
    'also',
    'back',
    'after',
    'use',
    'two',
    'how',
    'our',
    'work',
    'first',
    'well',
    'way',
    'even',
    'new',
    'want',
    'because',
    'any',
    'these',
    'give',
    'day',
    'most',
    'us',
    'roll',
    'form',
    'safe',
    'flat',
    'believe',
    'side',
    'begin',
    'indicate',
    'notice',
    'school',
    'sheet',
    'syllable',
    'skill',
    'verb',
    'log',
    'experience',
    'led',
    'blood',
    'iron',
    'bottom',
    'radio',
    'term',
    'act',
    'snow',
    'industry',
    'thin',
    'train',
    'bank',
    'cover',
    'use',
    'long',
    'arrive',
    'include',
    'found',
    'mountain',
    'design',
    'cold',
    'talk',
    'ship',
    'drive',
    'arm',
    'movie',
    'field',
    'rich',
    'rule',
    'pull',
    'son',
    'daughter',
    'garden',
    'language',
    'earth',
    'father',
    'mother',
    'brother',
    'sister',
    'friend',
    'love',
    'peace',
    'power',
    'money',
    'change',
    'water',
    'fire',
    'air',
    'earth',
    'plant',
    'animal',
    'human',
    'mind',
    'body',
    'house',
    'home',
    'city',
    'town',
    'country',
    'world',
    'life',
    'death',
    'time',
    'space',
    'light',
    'dark',
    'sound',
    'color',
    'art',
    'music',
    'book',
    'word',
    'letter',
    'number',
    'question',
    'answer',
    'problem',
    'solution',
    'beginning',
    'end',
    'start',
    'stop',
    'move',
    'stay'
];
const $9012767c86612ea9$export$3c8f612fad8f6996 = [
    "about",
    "above",
    "abuse",
    "actor",
    "acute",
    "admit",
    "adopt",
    "adult",
    "after",
    "again",
    "agent",
    "agree",
    "ahead",
    "alarm",
    "album",
    "alert",
    "alike",
    "alive",
    "allow",
    "alone",
    "along",
    "alter",
    "angel",
    "anger",
    "angle",
    "angry",
    "apart",
    "apple",
    "apply",
    "arena",
    "argue",
    "arise",
    "array",
    "aside",
    "asset",
    "avoid",
    "award",
    "aware",
    "badly",
    "baker",
    "bases",
    "basic",
    "bear",
    "beast",
    "begin",
    "being",
    "below",
    "bench",
    "birth",
    "black",
    "blame",
    "blind",
    "block",
    "blood",
    "board",
    "boost",
    "bound",
    "brain",
    "brand",
    "brave",
    "bread",
    "break",
    "breed",
    "brief",
    "bring",
    "broad",
    "brown",
    "build",
    "built",
    "buyer",
    "cable",
    "calif",
    "carry",
    "catch",
    "cause",
    "chain",
    "chair",
    "chaos",
    "charm",
    "chart",
    "chase",
    "cheap",
    "check",
    "chest",
    "chief",
    "child",
    "china",
    "chose",
    "civil",
    "claim",
    "class",
    "clean",
    "clear",
    "click",
    "climb",
    "clock",
    "close",
    "cloud",
    "coach",
    "coast",
    "could",
    "count",
    "court",
    "cover",
    "craft",
    "crash",
    "crazy",
    "cream",
    "crime",
    "cross",
    "crowd",
    "crown",
    "cruel",
    "curve",
    "cycle",
    "daily",
    "dance",
    "dated",
    "dealt",
    "death",
    "debut",
    "delay",
    "delta",
    "dense",
    "depot",
    "depth",
    "derby",
    "doubt",
    "dozen",
    "draft",
    "drama",
    "drank",
    "draw",
    "dream",
    "dress",
    "drill",
    "drink",
    "drive",
    "drove",
    "dying",
    "eager",
    "early",
    "earth",
    "eight",
    "elect",
    "elite",
    "empty",
    "enemy",
    "enjoy",
    "enter",
    "entry",
    "equal",
    "error",
    "event",
    "every",
    "exact",
    "exist",
    "extra",
    "faith",
    "false",
    "fault",
    "fence",
    "fever",
    "field",
    "fifth",
    "fifty",
    "fight",
    "final",
    "first",
    "fixed",
    "flash",
    "fleet",
    "floor",
    "fluid",
    "focus",
    "force",
    "forth",
    "forty",
    "forum",
    "found",
    "frame",
    "frank",
    "fraud",
    "fresh",
    "front",
    "fruit",
    "fully",
    "funny",
    "giant",
    "given",
    "glass",
    "globe",
    "going",
    "grace",
    "grade",
    "grand",
    "grant",
    "grass",
    "grave",
    "great",
    "green",
    "gross",
    "group",
    "grown",
    "guard",
    "guess",
    "guest",
    "guide",
    "happy",
    "heart",
    "heavy",
    "hence",
    "henry",
    "horse",
    "hotel",
    "house",
    "human",
    "ideal",
    "image",
    "imply",
    "index",
    "inner",
    "input",
    "issue",
    "joint",
    "judge",
    "known",
    "label",
    "large",
    "laser",
    "later",
    "laugh",
    "layer",
    "learn",
    "lease",
    "least",
    "leave",
    "legal",
    "lemon",
    "level",
    "lewis",
    "light",
    "limit",
    "links",
    "lives",
    "local",
    "logic",
    "loose",
    "lower",
    "lucky",
    "lunch",
    "lying",
    "magic",
    "major",
    "maker",
    "march",
    "maria",
    "match",
    "maybe",
    "mayor",
    "meant",
    "media",
    "metal",
    "might",
    "minor",
    "minute",
    "mixed",
    "model",
    "money",
    "month",
    "moral",
    "motor",
    "mount",
    "mouse",
    "mouth",
    "moved",
    "movie",
    "music",
    "needs",
    "never",
    "newly",
    "night",
    "noise",
    "north",
    "noted",
    "novel",
    "nurse",
    "occur",
    "ocean",
    "offer",
    "often",
    "order",
    "other",
    "ought",
    "outer",
    "owned",
    "owner",
    "paint",
    "panel",
    "paper",
    "paris",
    "party",
    "peace",
    "phase",
    "phone",
    "photo",
    "piano",
    "piece",
    "pilot",
    "pitch",
    "place",
    "plain",
    "plane",
    "plant",
    "plate",
    "point",
    "pound",
    "power",
    "press",
    "price",
    "pride",
    "prime",
    "print",
    "prior",
    "prize",
    "proof",
    "proud",
    "prove",
    "queen",
    "quick",
    "quiet",
    "quite",
    "radio",
    "raise",
    "range",
    "rapid",
    "ratio",
    "reach",
    "read",
    "ready",
    "real",
    "refer",
    "relax",
    "reply",
    "rider",
    "river",
    "rock",
    "rough",
    "round",
    "route",
    "royal",
    "rural",
    "scale",
    "scene",
    "scope",
    "score",
    "sense",
    "serve",
    "seven",
    "shall",
    "shape",
    "share",
    "sharp",
    "sheet",
    "shelf",
    "shell",
    "shift",
    "shine",
    "shirt",
    "shock",
    "shoot",
    "shore",
    "short",
    "shown",
    "sight",
    "silly",
    "since",
    "sixth",
    "sixty",
    "sized",
    "skill",
    "sleep",
    "slide",
    "slight",
    "smart",
    "smile",
    "smith",
    "smoke",
    "smooth",
    "snake",
    "solar",
    "solid",
    "solve",
    "sorry",
    "sound",
    "south",
    "space",
    "spare",
    "speak",
    "speed",
    "spell",
    "spend",
    "spoke",
    "sport",
    "square",
    "stage",
    "stake",
    "stand",
    "start",
    "state",
    "steam",
    "steel",
    "steep",
    "stick",
    "still",
    "stone",
    "stood",
    "store",
    "storm",
    "story",
    "strip",
    "stuck",
    "study",
    "stuff",
    "style",
    "sugar",
    "suite",
    "sunny",
    "super",
    "sure",
    "sweet",
    "swift",
    "swing",
    "table",
    "taken",
    "taste",
    "taxes",
    "teach",
    "teams",
    "teeth",
    "tells",
    "tense",
    "terms",
    "terry",
    "thank",
    "theft",
    "their",
    "theme",
    "there",
    "these",
    "thick",
    "thing",
    "think",
    "third",
    "those",
    "three",
    "threw",
    "throw",
    "thumb",
    "tiger",
    "tight",
    "timer",
    "title",
    "today",
    "tommy",
    "topic",
    "total",
    "touch",
    "tough",
    "tower",
    "track",
    "trade",
    "trail",
    "train",
    "trash",
    "treat",
    "trial",
    "tribe",
    "trick",
    "troop",
    "truck",
    "truly",
    "trump",
    "trust",
    "truth",
    "twice",
    "twins",
    "uncle",
    "under",
    "union",
    "unity",
    "until",
    "upper",
    "upset",
    "urban",
    "usual",
    "valid",
    "value",
    "video",
    "virus",
    "visit",
    "voice",
    "waste",
    "watch",
    "water",
    "wheel",
    "where",
    "which",
    "while",
    "white",
    "whole",
    "whose",
    "woman",
    "women",
    "world",
    "worry",
    "worse",
    "worst",
    "worth",
    "would",
    "write",
    "wrong",
    "wrote",
    "yield",
    "young",
    "yours",
    "youth",
    "worth",
    "would",
    "write"
];
const $9012767c86612ea9$export$ff5eaae6c9cdb1e9 = [
    "abacus",
    "abandon",
    "ability",
    "absence",
    "absolute",
    "academy",
    "accept",
    "accident",
    "account",
    "achieve",
    "acidify",
    "acknow",
    "acquire",
    "actress",
    "actually",
    "adamant",
    "address",
    "adeptly",
    "adjust",
    "admiral",
    "admit",
    "adopted",
    "advance",
    "adviser",
    "advocate",
    "affable",
    "affair",
    "afflict",
    "afraid",
    "agency",
    "agenda",
    "airport",
    "alarm",
    "alcohol",
    "alien",
    "aligned",
    "alleged",
    "alley",
    "alliance",
    "allowed",
    "alloy",
    "already",
    "alright",
    "alter",
    "amateur",
    "amazing",
    "ambient",
    "amongst",
    "ancient",
    "angelic",
    "anguish",
    "animate",
    "annoy",
    "annuity",
    "anomaly",
    "another",
    "anxious",
    "apology",
    "apparel",
    "appeal",
    "appear",
    "applaud",
    "approve",
    "archer",
    "archive",
    "arctic",
    "arduous",
    "arising",
    "armchair",
    "arrest",
    "article",
    "artisan",
    "ascribe",
    "ashamed",
    "aspire",
    "assault",
    "assemble",
    "assess",
    "assign",
    "assist",
    "assume",
    "assure",
    "athlete",
    "atlas",
    "atomize",
    "attempt",
    "attend",
    "attract",
    "auction",
    "audible",
    "audit",
    "augment",
    "authentic",
    "author",
    "autumn",
    "avalanche",
    "avenue",
    "average",
    "award",
    "aware",
    "awkward",
    "bachelor",
    "backbone",
    "backward",
    "balance",
    "balloon",
    "bandit",
    "bankrupt",
    "barbecue",
    "barely",
    "barrier",
    "baseball",
    "basement",
    "battery",
    "beaming",
    "beating",
    "beauty",
    "because",
    "become",
    "bedroom",
    "beefy",
    "began",
    "begin",
    "behave",
    "belief",
    "bell",
    "belong",
    "below",
    "belted",
    "beneath",
    "benefit",
    "besides",
    "between",
    "beyond",
    "bicycle",
    "bigger",
    "billion",
    "biology",
    "bird",
    "birthday",
    "bishop",
    "bitter",
    "blacken",
    "blame",
    "blanket",
    "blazing",
    "bless",
    "blizzard",
    "blocked",
    "bloom",
    "bluebird",
    "boarding",
    "boastful",
    "bodies",
    "boiling",
    "boldly",
    "bondage",
    "booklet",
    "boost",
    "boring",
    "borrow",
    "bottle",
    "bottom",
    "bought",
    "boulder",
    "boundary",
    "bouquet",
    "bowling",
    "bracelet",
    "bracket",
    "braided",
    "bravery",
    "breadth",
    "break",
    "breath",
    "breed",
    "breeze",
    "brick",
    "bridge",
    "briefly",
    "brighter",
    "brilliant",
    "bring",
    "briskly",
    "brittle",
    "broaden",
    "broccoli",
    "broken",
    "brother",
    "brought",
    "browser",
    "bruise",
    "brutal",
    "bubble",
    "bucket",
    "budget",
    "buffalo",
    "building",
    "bulk",
    "bulletin",
    "bumpy",
    "bundle",
    "burden",
    "bureaucracy",
    "burial",
    "burning",
    "burst",
    "burying",
    "bushes",
    "business",
    "busy",
    "butter",
    "button",
    "buyer",
    "bypass",
    "cabinet",
    "cactus",
    "cafeteria",
    "calculate",
    "calendar",
    "calling",
    "calmly",
    "camera",
    "campaign",
    "campus",
    "cancelled",
    "candidate",
    "cannon",
    "canvas",
    "capable",
    "capacity",
    "capital",
    "captain",
    "capture",
    "careful",
    "carpet",
    "carriage",
    "carrot",
    "carry",
    "cartoon",
    "cashier",
    "casino",
    "castle",
    "casual",
    "catastrophe",
    "catch",
    "category",
    "cattle",
    "caught",
    "caution",
    "cave",
    "ceiling",
    "celebrate",
    "celery",
    "cement",
    "censor",
    "century",
    "ceramic",
    "ceremony",
    "certain",
    "certify",
    "chain",
    "chairman",
    "chalk",
    "challenge",
    "chamber",
    "champion",
    "chapter",
    "character",
    "charity",
    "charming",
    "charter",
    "chase",
    "cheap",
    "cheerful",
    "cheese",
    "chemical",
    "chemist",
    "cherry",
    "chest",
    "chicken",
    "childhood",
    "chill",
    "chime",
    "chimney",
    "choose",
    "chorus",
    "christ",
    "chronic",
    "chuckle",
    "cigarette",
    "cinder",
    "circle",
    "circuit",
    "circular",
    "citizen",
    "city",
    "civil",
    "claim",
    "clarity",
    "clash",
    "classic",
    "clause",
    "cleaner",
    "clearly",
    "clergy",
    "climate",
    "climb",
    "clinic",
    "clock",
    "closely",
    "closet",
    "clothing",
    "cloudy",
    "cluster",
    "clutch",
    "coach",
    "coal",
    "coastal",
    "cocaine",
    "coconut",
    "coffee",
    "coherent",
    "coil",
    "coinage",
    "coldly",
    "collapse",
    "collar",
    "college",
    "colony",
    "colorful",
    "column",
    "combat",
    "combine",
    "comfort",
    "comic",
    "command",
    "comment",
    "commercial",
    "common",
    "compact",
    "company",
    "compare",
    "compel",
    "compile",
    "complex",
    "compose",
    "compound",
    "compressed",
    "compromise",
    "compute",
    "conceal",
    "concede",
    "conceive",
    "concept",
    "concern",
    "concert",
    "conclude",
    "concrete",
    "condemn",
    "condense",
    "conduct",
    "confess",
    "confident",
    "confirm",
    "conflict",
    "conform",
    "confuse",
    "congest",
    "connect",
    "consent",
    "consist",
    "console",
    "conspire",
    "constant",
    "construe",
    "consult",
    "contain",
    "content",
    "contest",
    "context",
    "control",
    "convene",
    "convert",
    "convict",
    "convince",
    "cooking",
    "cooling",
    "cooperate",
    "copper",
    "copying",
    "cordial",
    "corn",
    "corner",
    "corporate",
    "correct",
    "costly",
    "cottage",
    "cotton",
    "council",
    "counsel",
    "counter",
    "country",
    "courage",
    "courtesy",
    "courtyard",
    "cousin",
    "cover",
    "coward",
    "crack",
    "craft",
    "cramped",
    "crash",
    "crayon",
    "crazy",
    "cream",
    "create",
    "credible",
    "credit",
    "creek",
    "creep",
    "crest",
    "crew",
    "crime",
    "crisis",
    "crispy",
    "critic",
    "crop",
    "cross",
    "crowd"
];
const $9012767c86612ea9$export$44112b5d226bef28 = [
    "abandonment",
    "abbreviated",
    "aberration",
    "abolishment",
    "abomination",
    "abreaction",
    "absenteeism",
    "absolution",
    "absorptive",
    "abstraction",
    "accentuate",
    "acceptance",
    "accessional",
    "acclamation",
    "accommodate",
    "accompanying",
    "accomplished",
    "accordance",
    "accountable",
    "accrediting",
    "accumulated",
    "accusation",
    "achievement",
    "acknowledged",
    "acquaintance",
    "acquiescent",
    "acquisition",
    "adaptation",
    "addressing",
    "adequately",
    "adjustment",
    "administer",
    "admiration",
    "admittance",
    "admonishing",
    "adolescent",
    "adrenaline",
    "adversarial",
    "advertising",
    "advocating",
    "affectional",
    "affiliation",
    "affirmation",
    "aggregation",
    "aggression",
    "alphabetical",
    "altercation",
    "alternative",
    "altogether",
    "amalgamate",
    "ambiguously",
    "ameliorate",
    "amendments",
    "ammunition",
    "amplified",
    "analytical",
    "anarchist",
    "ancestral",
    "anecdotal",
    "anniversary",
    "announced",
    "annoyance",
    "antecedent",
    "anticipated",
    "antidote",
    "antiquated",
    "antiseptic",
    "anxiousness",
    "apologetic",
    "apostrophe",
    "apparatus",
    "apparent",
    "appealable",
    "appearance",
    "appellant",
    "appliance",
    "applicable",
    "appointed",
    "appreciable",
    "apprehend",
    "approached",
    "appropriate",
    "approval",
    "arbitrary",
    "architect",
    "arduously",
    "arrangement",
    "articulate",
    "artificially",
    "ascertained",
    "asphyxiate",
    "aspiration",
    "assassinate",
    "assemblage",
    "assessment",
    "assimilate",
    "assistance",
    "associate",
    "assortment",
    "astonishing",
    "astounding",
    "asymmetric",
    "atmosphere",
    "attachment",
    "attainment",
    "attempted",
    "attendance",
    "attendant",
    "attenuated",
    "attestation",
    "attractive",
    "attributable",
    "atypical",
    "auditorium",
    "auspicious",
    "authentic",
    "authority",
    "authorized",
    "autobiography",
    "automated",
    "autonomous",
    "availability",
    "avaricious",
    "avengeance",
    "avoidance",
    "awaiting",
    "awakening",
    "awkwardness",
    "bachelor",
    "backhanded",
    "backpacking",
    "bacterium",
    "bafflement",
    "balancing",
    "bandwidth",
    "bankruptcy",
    "barbiturate",
    "bargaining",
    "barricade",
    "basically",
    "battleship",
    "beautifully",
    "beginnings",
    "behavioral",
    "belongings",
    "benefactor",
    "beneficial",
    "benevolent",
    "bereavement",
    "beseeching",
    "bestseller",
    "beverage",
    "bewildering",
    "bicentennial",
    "bidirectional",
    "bilingual",
    "billionaire",
    "biographer",
    "biological",
    "bipartisan",
    "birthplace",
    "blackboard",
    "blameless",
    "blasphemous",
    "blindfold",
    "blindsided",
    "blockbuster",
    "bloodstream",
    "blueprint",
    "boisterous",
    "bolstering",
    "bombardment",
    "bookkeeper",
    "borderline",
    "bottomless",
    "boundaries",
    "brainstorm",
    "brandished",
    "breakdown",
    "breakfast",
    "breathless",
    "breathtaking",
    "bridegroom",
    "brilliance",
    "broadcast",
    "brokenhearted",
    "bureaucrat",
    "burglaries",
    "cacophony",
    "calamitous",
    "calculated",
    "calligraphy",
    "camaraderie",
    "cancellation",
    "candidacy",
    "capability",
    "capitalize",
    "capricious",
    "captivated",
    "carbonated",
    "carelessly",
    "caricature",
    "carpenter",
    "categorical",
    "celebrated",
    "celebrity",
    "censorship",
    "centralize",
    "certificate",
    "challenger",
    "champagne",
    "charitable",
    "charlatan",
    "chauffeur",
    "cheerleader",
    "choreograph",
    "christening",
    "chronically",
    "circumstantial",
    "citizenship",
    "civilian",
    "clarification",
    "classical",
    "classified",
    "classroom",
    "claustrophobic",
    "clergyman",
    "clientele",
    "clumsiness",
    "coexistence",
    "cognizant",
    "collaborate",
    "colleague",
    "collection",
    "collective",
    "collegiate",
    "collision",
    "colonel",
    "combatant",
    "combination",
    "comfortable",
    "commemorate",
    "commencement",
    "commendable",
    "commercial",
    "commission",
    "commitment",
    "commodity",
    "communicate",
    "community",
    "commuting",
    "comparable",
    "compassion",
    "compatible",
    "compensate",
    "compilation",
    "completely",
    "complexity",
    "compliance",
    "complication",
    "compliment",
    "comprehend",
    "compressed",
    "compromise",
    "compulsion",
    "concealment",
    "concentrate",
    "conception",
    "conceptual",
    "concession",
    "conciliate",
    "conclusion",
    "concurrent",
    "condemnation",
    "condescend",
    "condition",
    "conducive",
    "conference",
    "confidence",
    "confidential",
    "configuration",
    "confirmation",
    "conformity",
    "confrontation",
    "confusion",
    "congestion",
    "congratulate",
    "congregation",
    "conjunction",
    "connection",
    "conscience",
    "conscious",
    "consecutive",
    "consensus",
    "conservative",
    "considerable",
    "consignment",
    "consistent",
    "consolation",
    "conspicuous",
    "conspiracy",
    "constantly",
    "constellation",
    "consternation",
    "constituent",
    "constitute",
    "constraint",
    "construction",
    "consultation",
    "consumption",
    "contaminate",
    "contemplate",
    "contemporary",
    "contemptuous",
    "contend",
    "contentment",
    "continually",
    "contradict",
    "contribute",
    "contrition",
    "controversial",
    "convenience",
    "conversation",
    "conversion",
    "conviction",
    "cooperate",
    "coordinate",
    "copulation",
    "cornerstone",
    "corporation",
    "correction",
    "correlation",
    "correspond",
    "corruption",
    "counseling",
    "counterfeit",
    "counterpart",
    "courteously",
    "craftsmanship",
    "creativity",
    "credibility",
    "criminality",
    "criticism",
    "crucifixion",
    "cultivation",
    "cumulative",
    "curriculum",
    "cushioning",
    "cynicalness",
    "decentralize",
    "deciphered",
    "declaration",
    "declining",
    "decomposed",
    "decorative",
    "decremental",
    "dedication",
    "deferential",
    "defibrillator",
    "definitely",
    "definition",
    "definitive",
    "deforestation",
    "degenerate",
    "degradation",
    "dehydrated",
    "delectable",
    "delegation",
    "deliberate",
    "delineation",
    "delinquent",
    "deliverance",
    "demographic",
    "demolition",
    "demonstrate",
    "denominate",
    "dependable",
    "depression",
    "derivative",
    "descendant",
    "descriptive",
    "desecration",
    "desperation",
    "destination",
    "destruction",
    "detachment",
    "detergent",
    "deteriorate",
    "determinate",
    "detrimental",
    "devastation",
    "developing",
    "deviation",
    "devotional",
    "diagnosis",
    "dialectical",
    "diametrical",
    "dictatorship",
    "difference",
    "difficulty",
    "digestible",
    "dilettante",
    "diminutive",
    "diplomatic",
    "direction",
    "disability",
    "disadvantage",
    "disagreeable",
    "disappear",
    "disappoint",
    "disapproval",
    "disastrous",
    "disburse",
    "discernible",
    "discipline",
    "discomfort",
    "disconcerting",
    "disconnect",
    "discordant",
    "discourage",
    "discover",
    "discreet",
    "discrepancy",
    "discriminate",
    "discussion",
    "disembark",
    "disenchant",
    "disfigure",
    "disgraceful",
    "disgruntled",
    "disguised",
    "disgusting",
    "dishonesty",
    "disillusion",
    "disinfect",
    "disinherit",
    "disintegrate",
    "disinterest",
    "disjointed",
    "disjunctive",
    "dislocated",
    "dismantle",
    "dismissive",
    "disobedient",
    "disorderly",
    "disparate",
    "dispensary",
    "dispersion",
    "disposable",
    "disproportionate"
];


const $0798bf1143a9ed1c$export$a9b4cb1bb6b70d3e = [
    "A calm morning can change the pace of an entire day. When the room is quiet and the mind is focused, even difficult work feels possible. Small steps repeated with care often become the difference between drifting and finishing well.",
    "Learning to type accurately is less about speed at the beginning and more about patience. The hands remember through repetition, and the mind learns to trust a steady rhythm. With enough practice, accuracy becomes the foundation of speed.",
    "Clear thinking grows from clear habits. A short paragraph typed carefully can train attention better than a long session of rushed mistakes. The goal is not perfection in one attempt but consistency across many attempts.",
    "Mistakes are not failures; they are feedback. Each time a finger presses the wrong key, the brain receives a signal to adjust. Over time, these small corrections build neural pathways that make accuracy automatic. The typist who embraces errors as teachers learns faster than the one who fears them.",
    "The space between thought and action is where skill lives. When you think of a word and your fingers type it without conscious effort, you have bridged that space. Typing practice is not just about letters on a screen; it is about making the invisible connection between mind and body stronger.",
    "Fatigue is a silent enemy of accuracy. After twenty minutes of focused typing, the fingers grow heavy and the eyes begin to blur. A short break of two minutes restores concentration better than pushing through for an hour. Smart practice includes rest, not just repetition.",
    "Reading aloud while typing engages multiple senses at once. The eyes see the text, the ears hear the voice, and the fingers move in response. This layered approach reinforces learning more deeply than silent typing alone. Try it for five minutes and notice the difference.",
    "The backspace key is a tool, not a shame. Every skilled typist uses it constantly, especially when learning something new. The difference between a beginner and an expert is not that experts never err; it is that they correct errors so quickly that no one notices.",
    "Setting a timer changes your relationship with time. Instead of watching the clock and wishing for the session to end, you focus entirely on the task. Ten minutes of intense focus produces more improvement than thirty minutes of distracted effort. Let the timer be your coach.",
    "Your posture affects your typing more than you think. When the spine is straight and the wrists are level, blood flows freely to the fingers. Slouching compresses nerves and slows reaction time. A small adjustment in seating can yield a large gain in accuracy.",
    "Typing is a dance of small muscles. The fingers do not need to strike hard; they need to strike true. Too much force creates tension, and tension slows movement. Relaxed hands move faster and make fewer mistakes. Practice lightness as much as accuracy.",
    "The home row is your anchor. When you return your fingers to ASDF and JKL; after every word, you give your hands a known reference point. This simple reset prevents drift and reduces the cognitive load of finding keys. Home row is not a cage; it is a compass.",
    'Typing common words well is more useful than typing rare words perfectly. Words like "the", "and", "of", "to", and "in" make up half of all English text. Mastering these short words pays dividends across every sentence you will ever type.',
    "Look at the screen, not at your hands. This is the hardest habit to build but the most valuable. When you look down, you break the connection between thought and action. When you keep your eyes up, you force your fingers to learn through feel. Trust the process.",
    "Speed will come, but accuracy must be invited. If you chase speed before accuracy, you teach your hands to make mistakes quickly. If you prioritize accuracy first, speed arrives naturally as a byproduct. Slow is smooth, and smooth becomes fast.",
    "Every typing session is a conversation between your present self and your future self. The effort you invest now builds capability for later. A paragraph typed carefully today saves you from struggling through the same paragraph tomorrow. Practice is delayed gratification made visible.",
    "The first five minutes of practice are the most important. In those minutes, you set the tempo and the attitude. If you start rushed and frustrated, the whole session follows that tone. If you start slow and patient, the rest becomes easier. Warm up your mind before your fingers.",
    "Compare yourself only to your past self, not to anyone else. Someone else has been practicing for years; you have been practicing for weeks. The only meaningful question is whether you are better today than you were yesterday. That is a race you can win every day.",
    "Typing punctuation accurately separates casual typists from professionals. The period, comma, question mark, and apostrophe are small but mighty. A missing comma changes meaning; a misplaced apostrophe confuses readers. Give punctuation the same attention as letters.",
    "Your brain learns while you sleep. A hard practice session followed by a good night of rest produces more improvement than the same amount of practice spread across tired hours. Trust the overnight consolidation. Practice hard, then sleep well.",
    "Boredom is not a sign to stop; it is a sign to go deeper. When typing feels monotonous, challenge yourself with a new exercise. Try typing with eyes closed for one sentence. Try typing a poem instead of prose. Boredom is the mind asking for novelty, not for rest.",
    "The shift keys are often neglected. Many typists use only the left shift key, creating imbalance and strain. Train yourself to use the right shift for left-hand letters and left shift for right-hand letters. This symmetry reduces reaching and increases speed over time.",
    'Typing is a measure of attention, not just dexterity. When your mind wanders, your fingers make strange errors. You type "form" instead of "from" or "teh" instead of "the". These mistakes vanish when attention returns. Practice focus as much as finger placement.',
    "A single paragraph typed ten times is better than ten paragraphs typed once. Repetition with intention builds muscle memory. The first time is exploration; the fifth time is refinement; the tenth time is mastery. Do not confuse variety with progress.",
    "Your environment shapes your typing. A cluttered desk clutters the mind. A noisy room divides attention. Take thirty seconds before practice to clear the space and silence distractions. This small ritual signals to your brain that typing time is serious time.",
    "Typing numbers and symbols is a separate skill from typing letters. The top row of keys requires different finger movements and more reaching. Practice number rows separately before integrating them into sentences. Break complex skills into pieces, then assemble.",
    "Celebrate small victories. Did you type a difficult word correctly on the first try? Notice it. Did you finish a paragraph without looking at your hands? Acknowledge it. These small wins build momentum. Progress is made of tiny successes, not giant leaps.",
    "The backspace key can become a crutch. If you correct every error immediately, you never feel the weight of mistakes. Try leaving one error per paragraph uncorrected. Read it back. Feel the discomfort. Then correct it. Discomfort is where growth begins.",
    "Typing is like playing a musical instrument. The fingers must know their positions without conscious thought. The rhythm must be steady, not frantic. And the player must listen to the output, not just watch the movements. Treat typing as performance, not as chore.",
    "A ten-minute practice every day beats a two-hour practice once a week. Daily repetition keeps the neural pathways active and growing. Weekly marathons cause fatigue and frustration. Consistency is more powerful than intensity. Show up every day, even for a little while.",
    "Your breath affects your typing speed. Shallow breathing increases tension and reduces oxygen to the brain. Three deep breaths before a typing session calm the nervous system and prepare the fingers. Typing is physical; treat it with the same respect as exercise.",
    "The spacebar is the most used key on the keyboard, yet it is often ignored. Practice hitting the spacebar with the same thumb every time. A consistent thumb position prevents hesitation between words and creates a clean rhythm. Small details make big differences.",
    "Trust the process even when progress feels invisible. Some days you will backspace more than you type forward. Some days every word feels wrong. These are not failures; they are the plateau before a jump. Keep going. The breakthrough comes without warning."
];


async function $9b3e6cedef55f70c$export$2627036b234e54da(count = 15, level = "medium") {
    try {
        let wordLength = $9b3e6cedef55f70c$var$getLevelWordLength(level);
        const response = await fetch(`${(0, $45af14c00f07ca1e$export$e6ea90c0ef135c03)}&words=${count}&length=${wordLength}`);
        if (!response.ok) throw new Error("API request failed");
        const words = await response.json();
        const wordsArray = words.map((item)=>item.word);
        return wordsArray;
    } catch (error) {
        console.warn("Using fallback words:", error);
        let wordLength = $9b3e6cedef55f70c$var$getLevelWordLength(level);
        return $9b3e6cedef55f70c$var$getRandomFallbackWords(wordLength, count);
    }
}
function $9b3e6cedef55f70c$var$getLevelWordLength(level) {
    switch(level){
        case "easy":
            return 5;
        case "hard":
            return 11;
        default:
            return 8;
    }
}
function $9b3e6cedef55f70c$var$getRandomFallbackWords(wordLength, count) {
    let shuffled = [
        ...(0, $9012767c86612ea9$export$493d50d03d937fb6)
    ];
    if (wordLength == 5) shuffled = [
        ...(0, $9012767c86612ea9$export$3c8f612fad8f6996)
    ];
    else if (wordLength == 8) shuffled = [
        ...(0, $9012767c86612ea9$export$ff5eaae6c9cdb1e9)
    ];
    else if (wordLength == 11) shuffled = [
        ...(0, $9012767c86612ea9$export$44112b5d226bef28)
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [
            shuffled[j],
            shuffled[i]
        ];
    }
    return shuffled.slice(0, count);
}
function $9b3e6cedef55f70c$export$78b3e1cc6edddec(wordList, count) {
    const shuffled = [
        ...wordList
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [
            shuffled[j],
            shuffled[i]
        ];
    }
    return shuffled.slice(0, count);
}
async function $9b3e6cedef55f70c$export$be40b4f2de324d13() {
    try {
        const response = await fetch((0, $45af14c00f07ca1e$export$88f6f8ff4bba2e2f));
        if (!response.ok) throw new Error("Essay API request failed");
        const paragraph = await response.text();
        const normalized = $9b3e6cedef55f70c$var$normalizeParagraph(paragraph);
        if (!normalized) throw new Error("Empty essay response");
        return normalized;
    } catch (error) {
        console.warn("Using fallback essay paragraph:", error);
        return (0, $0798bf1143a9ed1c$export$a9b4cb1bb6b70d3e)[Math.floor(Math.random() * (0, $0798bf1143a9ed1c$export$a9b4cb1bb6b70d3e).length)];
    }
}
function $9b3e6cedef55f70c$var$normalizeParagraph(text) {
    return text.replace(/\s+/g, " ").trim();
}




//
// Scoring helpers
//
function $d53cd9aa2ae42e0c$var$getScoreIncrease(difficulty) {
    return ({
        easy: 10,
        hard: 30
    })[difficulty] || 20;
}
function $d53cd9aa2ae42e0c$var$getHealthChange(difficulty, correct) {
    if (correct) {
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") return ({
            easy: 3,
            hard: 1
        })[difficulty] || 2;
        return ({
            easy: 2,
            hard: 0
        })[difficulty] || 1;
    }
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") return difficulty === "hard" ? -20 : -8;
    return difficulty === "hard" ? -15 : -5;
}
function $d53cd9aa2ae42e0c$var$getEssayPenalty() {
    switch((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty){
        case "easy":
            return 1;
        case "hard":
            return 3;
        default:
            return 2;
    }
}
function $d53cd9aa2ae42e0c$var$getEssaySkipPenalty() {
    switch((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty){
        case "easy":
            return 15;
        case "hard":
            return 35;
        default:
            return 25;
    }
}
//
// Survival mode
//
function $d53cd9aa2ae42e0c$var$startSurvivalMode() {
    if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval) {
        clearInterval((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval);
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval = null;
    }
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive = true;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalLastTypedTime = Date.now();
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = 0;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval = setInterval(()=>{
        if (!(0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive || !(0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive || (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode !== "survival") {
            if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode !== "survival") $d53cd9aa2ae42e0c$var$stopSurvivalMode();
            return;
        }
        let decayRate = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalBaseDecay;
        switch((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty){
            case "easy":
                decayRate = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalBaseDecay * 0.8;
                break;
            case "hard":
                decayRate = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalBaseDecay * 1.5;
                break;
            default:
                decayRate = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalBaseDecay;
        }
        if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo > 0 && Date.now() - (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalLastTypedTime > 2000) {
            (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = Math.max(0, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo - 1);
            (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
        }
        (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.max(0, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health - decayRate);
        (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health, (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped));
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health < 30) {
            (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl?.classList.add("low-health");
            document.body.classList.add("health-warning");
        } else {
            (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl?.classList.remove("low-health");
            document.body.classList.remove("health-warning");
        }
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health <= 0) $d53cd9aa2ae42e0c$var$endGame();
    }, 1000);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay?.classList.add("survival-mode");
}
function $d53cd9aa2ae42e0c$var$stopSurvivalMode() {
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive = false;
    if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval) {
        clearInterval((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval);
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval = null;
    }
    if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalComboTimer) {
        clearTimeout((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalComboTimer);
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalComboTimer = null;
    }
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = 0;
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).healthEl?.classList.remove("low-health");
    document.body.classList.remove("health-warning");
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).currentWordDisplay?.classList.remove("survival-mode");
    const comboElement = document.getElementById("comboDisplay");
    if (comboElement) comboElement.parentElement?.remove();
}
//
// Game flow: load, reset, end
//
async function $d53cd9aa2ae42e0c$var$loadNewContent() {
    if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive || (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval) $d53cd9aa2ae42e0c$var$stopSurvivalMode();
    (0, $8819aed3de4d5aa9$export$36595ab25e995ab3)();
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay = await (0, $9b3e6cedef55f70c$export$be40b4f2de324d13)();
        (0, $8819aed3de4d5aa9$export$35f7926bd3d84ff1)();
    } else if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList = await (0, $9b3e6cedef55f70c$export$2627036b234e54da)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsCount, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty);
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex = 0;
        (0, $8819aed3de4d5aa9$export$42f3f63a098c5667)();
        (0, $8819aed3de4d5aa9$export$9d95f35147c2490c)();
        $d53cd9aa2ae42e0c$var$startSurvivalMode();
    } else {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList = await (0, $9b3e6cedef55f70c$export$2627036b234e54da)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsCount, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty);
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex = 0;
        (0, $8819aed3de4d5aa9$export$42f3f63a098c5667)();
        (0, $8819aed3de4d5aa9$export$9d95f35147c2490c)();
    }
    (0, $8819aed3de4d5aa9$export$841ecefba1e9cb2e)();
}
async function $d53cd9aa2ae42e0c$var$loadNewEssay() {
    try {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay = await (0, $9b3e6cedef55f70c$export$be40b4f2de324d13)();
        (0, $8819aed3de4d5aa9$export$35f7926bd3d84ff1)();
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).essayProgress = 0;
        if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value = "";
        if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar.style.width = "0%";
    } catch (error) {
        console.error("Failed to load new essay:", error);
    }
}
async function $d53cd9aa2ae42e0c$var$loadMoreWords() {
    const newWords = await (0, $9b3e6cedef55f70c$export$2627036b234e54da)(15, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty);
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.push(...newWords);
    (0, $8819aed3de4d5aa9$export$42f3f63a098c5667)();
    (0, $8819aed3de4d5aa9$export$9d95f35147c2490c)();
}
function $d53cd9aa2ae42e0c$var$resetGameLogic() {
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive = true;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime = null;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped = 0;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = 0;
    (0, $4ca38318c11c7fd1$export$ee55a0351e6e0fac)();
    (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)(0, 100, 0);
    (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
}
async function $d53cd9aa2ae42e0c$var$resetGame() {
    if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive || (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalDecayInterval) $d53cd9aa2ae42e0c$var$stopSurvivalMode();
    (0, $8819aed3de4d5aa9$export$85aadf8ace5d5dad)();
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive = true;
    (0, $4ca38318c11c7fd1$export$ee55a0351e6e0fac)();
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty = (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty;
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode = (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime = null;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = 0;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay = "";
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).essayProgress = 0;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex = 0;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped = 0;
    (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health, 0);
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
    else {
        const comboElement = document.getElementById("comboDisplay");
        if (comboElement) comboElement.parentElement?.remove();
    }
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput) {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value = "";
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.disabled = false;
    }
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).essayDisplay.innerHTML = "";
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar) (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).progressBar.style.width = "0%";
    await $d53cd9aa2ae42e0c$var$loadNewContent();
    (0, $c7e6200d021cfc4e$export$b11a7e24e0f6e0cc)();
}
function $d53cd9aa2ae42e0c$var$endGame() {
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive = false;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" || (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive) $d53cd9aa2ae42e0c$var$stopSurvivalMode();
    const finalWPM = (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, Math.max(1, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped));
    (0, $c7e6200d021cfc4e$export$bcb53ae2a77812e7)("GAME OVER", (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, finalWPM);
}
function $d53cd9aa2ae42e0c$var$finishEssay() {
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive = false;
    const finalWPM = (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, Math.max(1, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped));
    const title = (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" ? "SURVIVAL MODE COMPLETE!" : "Essay completed";
    (0, $c7e6200d021cfc4e$export$bcb53ae2a77812e7)(title, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, finalWPM);
    (0, $8819aed3de4d5aa9$export$85aadf8ace5d5dad)();
}
function $d53cd9aa2ae42e0c$var$saveGameScore() {
    const playerName = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).playerNameInput?.value.trim() || "Anonymous";
    (0, $b1e98e38dc5653da$export$ab10ae45fda35d88)(playerName, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty);
    (0, $c7e6200d021cfc4e$export$b11a7e24e0f6e0cc)();
    $d53cd9aa2ae42e0c$var$resetGame();
}
//
// Game interaction: typing, word checking, skipping
//
function $d53cd9aa2ae42e0c$var$handleTyping() {
    if (!(0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive) return;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" && (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive) (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalLastTypedTime = Date.now();
    if (!(0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime && (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value.length > 0) (0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime = Date.now();
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        $d53cd9aa2ae42e0c$var$updateEssayState();
        return;
    }
    (0, $8819aed3de4d5aa9$export$55220155eeb8e52c)();
}
function $d53cd9aa2ae42e0c$var$handleKeyDown(e) {
    if (!(0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive) return;
    if (((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "word" || (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") && e.key === "Enter") {
        e.preventDefault();
        $d53cd9aa2ae42e0c$var$checkWord();
    }
}
function $d53cd9aa2ae42e0c$var$updateEssayState() {
    const typed = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value;
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).essayProgress = typed.length;
    (0, $8819aed3de4d5aa9$export$35f7926bd3d84ff1)();
    const target = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay;
    let correctChars = 0;
    const maxLength = Math.min(typed.length, target.length);
    for(let i = 0; i < maxLength; i++)if (typed[i] === target[i]) correctChars++;
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score = correctChars;
    let mistakes = 0;
    for(let i = 0; i < maxLength; i++)if (typed[i] !== target[i]) mistakes++;
    if (!(0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime && typed.length > 0) (0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime = Date.now();
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.max(0, 100 - mistakes * $d53cd9aa2ae42e0c$var$getEssayPenalty());
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).wpm = (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, Math.max(1, Math.floor(typed.length / 5)));
    (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).wpm);
    if (typed.length === (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentEssay.length) {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped = Math.max(1, Math.floor(typed.length / 5));
        $d53cd9aa2ae42e0c$var$finishEssay();
    }
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health <= 0) $d53cd9aa2ae42e0c$var$endGame();
}
function $d53cd9aa2ae42e0c$var$checkWord() {
    const currentWord = (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList[(0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex];
    const userWord = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value.trim().toLowerCase();
    const isCorrect = userWord === currentWord.toLowerCase();
    if (!(0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime) (0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime = Date.now();
    if (isCorrect) {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.add("correct");
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped++;
        let scoreIncrease = $d53cd9aa2ae42e0c$var$getScoreIncrease((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty);
        let healthIncrease = $d53cd9aa2ae42e0c$var$getHealthChange((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty, true);
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") {
            (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = Math.min(20, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo + 1);
            (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalLastTypedTime = Date.now();
            const comboBonus = Math.floor((0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo / 3);
            scoreIncrease += comboBonus;
            healthIncrease += Math.floor(comboBonus / 2);
            (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
            const comboElement = document.getElementById("comboDisplay");
            if (comboElement) {
                comboElement.classList.add("combo-pop");
                setTimeout(()=>comboElement.classList.remove("combo-pop"), 200);
            }
        }
        (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score += scoreIncrease;
        (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.min(100, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health + healthIncrease);
    } else {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.add("wrong");
        (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.max(0, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health + $d53cd9aa2ae42e0c$var$getHealthChange((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty, false));
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") {
            (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = Math.max(0, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo - 3);
            (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
        }
    }
    (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, Math.round((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health), (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped));
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health <= 0) {
        $d53cd9aa2ae42e0c$var$endGame();
        return;
    }
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex++;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" && (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex >= (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.length - 5) $d53cd9aa2ae42e0c$var$loadMoreWords();
    else if ((0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex >= (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordList.length) {
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") $d53cd9aa2ae42e0c$var$loadMoreWords();
        else {
            $d53cd9aa2ae42e0c$var$endGame();
            return;
        }
    } else (0, $8819aed3de4d5aa9$export$42f3f63a098c5667)();
    (0, $8819aed3de4d5aa9$export$9d95f35147c2490c)();
    setTimeout(()=>{
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.classList.remove("correct", "wrong");
    }, 200);
}
function $d53cd9aa2ae42e0c$var$skipCurrentTask() {
    if (!(0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).gameActive) return;
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "essay") {
        const penalty = $d53cd9aa2ae42e0c$var$getEssaySkipPenalty();
        (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.max(0, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health - penalty);
        $d53cd9aa2ae42e0c$var$loadNewEssay();
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value = "";
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).essayProgress = 0;
        (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health, (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, Math.max(1, Math.floor((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.value.length / 5))));
        if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health <= 0) $d53cd9aa2ae42e0c$var$endGame();
        return;
    }
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health = Math.max(0, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health - 5);
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival") {
        (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo = Math.max(0, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalCombo - 2);
        (0, $8819aed3de4d5aa9$export$d9daadad6102d0bd)();
    }
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health <= 0) {
        $d53cd9aa2ae42e0c$var$endGame();
        return;
    }
    (0, $4ca38318c11c7fd1$export$874fd8712028ad21).currentWordIndex++;
    (0, $8819aed3de4d5aa9$export$42f3f63a098c5667)();
    (0, $8819aed3de4d5aa9$export$9d95f35147c2490c)();
    (0, $8819aed3de4d5aa9$export$5b188b9c6119dc76)((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).score, (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).health, (0, $14014bd8d985f76e$export$483f8f5e36a4d64f)((0, $4ca38318c11c7fd1$export$874fd8712028ad21).startTime, (0, $4ca38318c11c7fd1$export$874fd8712028ad21).wordsTyped));
}
function $d53cd9aa2ae42e0c$var$setDifficulty(difficulty) {
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).difficulty = difficulty;
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).difficultyBtns.forEach((btn)=>{
        btn.classList.toggle("active", btn.dataset.diff === difficulty);
    });
    $d53cd9aa2ae42e0c$var$resetGame();
}
function $d53cd9aa2ae42e0c$var$setMode(mode) {
    if ((0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode === "survival" && (0, $4ca38318c11c7fd1$export$874fd8712028ad21).survivalModeActive) $d53cd9aa2ae42e0c$var$stopSurvivalMode();
    (0, $4ca38318c11c7fd1$export$8e361a1ffbebf172).mode = mode;
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeBtns.forEach((btn)=>{
        btn.classList.toggle("active", btn.dataset.mode === mode);
    });
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeHint) {
        if (mode === "essay") (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeHint.textContent = "Type the full paragraph exactly as shown.";
        else if (mode === "survival") (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeHint.textContent = "SURVIVAL MODE: Health decays over time! Type quickly to stay alive. Each correct word gives bonus health and increases your combo!";
        else (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeHint.textContent = "Type each word and press Enter.";
    }
    if ((0, $79d266cbe2073e61$export$7a5d735b2ab6389d).inputHint) {
        if (mode === "essay") (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).inputHint.textContent = "essay mode highlights mistakes live.";
        else if (mode === "survival") (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).inputHint.textContent = "Type words FAST! Health decays every second. Combos give bonus points and health!";
        else (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).inputHint.textContent = "Type each word and press Enter.";
    }
    const comboElement = document.getElementById("comboDisplay");
    if (comboElement && mode !== "survival") comboElement.parentElement?.remove();
    $d53cd9aa2ae42e0c$var$resetGame();
}
//
// Event handlers
//
function $d53cd9aa2ae42e0c$var$handleDocumentClick(event) {
    if (!event.target.closest(".navbar")) {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).navToggle.setAttribute("aria-expanded", "false");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).nav.classList.remove("is-open");
    }
}
function $d53cd9aa2ae42e0c$var$handleNavToggle() {
    const isExpanded = (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).navToggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).navToggle.setAttribute("aria-expanded", "false");
        (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).nav.classList.remove("is-open");
        return;
    }
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).navToggle.setAttribute("aria-expanded", "true");
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).nav.classList.add("is-open");
}
async function $d53cd9aa2ae42e0c$export$2cd8252107eb640b() {
    (0, $8819aed3de4d5aa9$export$85aadf8ace5d5dad)();
    const initialTheme = (0, $ace5d9ab79ecc0da$export$a1d87755f3c9500d)();
    (0, $ace5d9ab79ecc0da$export$49e16ec648d05eb2)(initialTheme, (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).themeToggle, (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).themeContext);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).themeToggle?.addEventListener("click", (0, $ace5d9ab79ecc0da$export$55990aefc4a243a0));
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).navToggle?.addEventListener("click", $d53cd9aa2ae42e0c$var$handleNavToggle);
    document.addEventListener("click", $d53cd9aa2ae42e0c$var$handleDocumentClick);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput?.addEventListener("input", $d53cd9aa2ae42e0c$var$handleTyping);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput?.addEventListener("keydown", $d53cd9aa2ae42e0c$var$handleKeyDown);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).saveScore?.addEventListener("click", $d53cd9aa2ae42e0c$var$saveGameScore);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).playAgain?.addEventListener("click", ()=>{
        (0, $c7e6200d021cfc4e$export$b11a7e24e0f6e0cc)();
        $d53cd9aa2ae42e0c$var$resetGame();
    });
    document.querySelector('[data-nav="leaderboard"]').addEventListener("click", (0, $c7e6200d021cfc4e$export$3acec85c603510fd));
    document.querySelector('[data-nav="about"]').addEventListener("click", (0, $c7e6200d021cfc4e$export$bb9d9652d2452909));
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modalCloseBtns.forEach((close)=>{
        close.addEventListener("click", (0, $c7e6200d021cfc4e$export$b11a7e24e0f6e0cc));
    });
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).leaderboardFilter.forEach((filter)=>{
        filter.addEventListener("click", ()=>{
            (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).leaderboardFilter.forEach((f)=>f.classList.remove("active"));
            filter.classList.add("active");
            (0, $8819aed3de4d5aa9$export$a26debe12f9d939f)(filter.dataset.lb);
        });
    });
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).difficultyBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>$d53cd9aa2ae42e0c$var$setDifficulty(btn.dataset.diff));
    });
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).modeBtns.forEach((btn)=>{
        btn.addEventListener("click", ()=>$d53cd9aa2ae42e0c$var$setMode(btn.dataset.mode));
    });
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).resetBtn.addEventListener("click", $d53cd9aa2ae42e0c$var$resetGame);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).skipBtn.addEventListener("click", $d53cd9aa2ae42e0c$var$skipCurrentTask);
    (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).commandTrigger.addEventListener("click", ()=>(0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.focus());
    document.addEventListener("keydown", (e)=>{
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
            e.preventDefault();
            (0, $79d266cbe2073e61$export$7a5d735b2ab6389d).userInput.focus();
        }
    });
    await $d53cd9aa2ae42e0c$var$loadNewContent();
    $d53cd9aa2ae42e0c$var$resetGameLogic();
}


if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", (0, $d53cd9aa2ae42e0c$export$2cd8252107eb640b));
else (0, $d53cd9aa2ae42e0c$export$2cd8252107eb640b)();


//# sourceMappingURL=vanilla-typing-game.fd78a1a9.js.map
